import React from 'react';
export function Author() {
  return <section className="py-16 bg-white" data-id="element-17">
      <div className="container mx-auto px-4" data-id="element-18">
        <div className="max-w-4xl mx-auto" data-id="element-19">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6 text-center" data-id="element-20">
            ¿Quién Está Detrás?
          </h2>
          <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-21">
            <div className="md:w-1/2" data-id="element-22">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wjNrLSJGGMy8Wz5Vn2Gzeq/Generated_Image_September_20%2C_2025_-_9_47AM.png" alt="María Hernández - Educadora Bilingüe" className="rounded-lg shadow-md max-w-full" data-id="element-23" />
            </div>
            <div className="md:w-1/2" data-id="element-24">
              <p className="text-gray-700 mb-4" data-id="element-25">
                La guía fue creada por{' '}
                <span className="font-semibold text-orange-600" data-id="element-26">
                  María Hernández
                </span>
                , educadora bilingüe con más de 15 años enseñando a familias
                hispanas en EE.UU. Y madre de dos hijos bilingües.
              </p>
              <p className="text-gray-700 mb-6" data-id="element-27">
                Su misión es simple:{' '}
                <span className="italic" data-id="element-28">
                  Que ningún niño pierda el idioma, la cultura… ni la conexión
                  con sus raíces.
                </span>
              </p>
              <div className="bg-orange-50 p-4 rounded-md border-l-4 border-orange-500" data-id="element-29">
                <p className="text-gray-700 italic" data-id="element-30">
                  "Cada vez que un niño deja de hablar español, perdemos no solo
                  un idioma, sino toda una conexión con nuestra historia,
                  nuestras tradiciones y nuestra identidad. Mi trabajo es
                  asegurarme de que eso no suceda."
                </p>
                <p className="text-right mt-2 text-gray-600 font-medium" data-id="element-31">
                  — María Hernández
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}